<template>
  <router-view />
</template>

<script lang="ts" setup>
document.body.classList.add("bare");
</script>

<style lang="scss">
html {
  background-color: white !important;
}
</style>